import { TimeLine } from '../components/TimeLine/TimeLine';
import { InBank } from '../components/InBank/InBank';
import './Skins.css';
import { Avatar } from '../../../components/Avatar/Avatar';
import { LineSkin } from '../components/LineSkinContainer/LineSkin';
import { Border } from '../../../components/Border/Border';
import { Dispatch, SetStateAction } from 'react';

export const Skins = ({ setIsInventoryOpen }: { setIsInventoryOpen: Dispatch<SetStateAction<boolean>> }) => {
    return (
        <div className="classic__skins">
            <div className="classic__skins-container">
                <TimeLine />
                <Border />
                <InBank />
            </div>
            <div className="classic__skins-chance-container">
                <div className="classic__skins-avatar-team-container">
                    <span className="classic__skins-avatar-team-text">gang gangsta 20.57%</span>
                    <div className="classic__skins-avatar-container">
                        <Avatar />
                        <span className="classic__skins-avatar-chance">42.85%</span>
                    </div>
                    <div className="classic__skins-avatar-container">
                        <Avatar />
                        <span className="classic__skins-avatar-chance">42.85%</span>
                    </div>
                </div>

                <div className="classic__skins-avatar-container">
                    <Avatar />
                    <span className="classic__skins-avatar-chance">42.85%</span>
                </div>
                <div className="classic__skins-avatar-container">
                    <Avatar />
                    <span className="classic__skins-avatar-chance">42.85%</span>
                </div>
                <div className="classic__skins-avatar-container">
                    <Avatar />
                    <span className="classic__skins-avatar-chance">42.85%</span>
                </div>
                <div className="classic__skins-avatar-container">
                    <Avatar />
                    <span className="classic__skins-avatar-chance">42.85%</span>
                </div>
                <div className="classic__skins-avatar-container">
                    <Avatar />
                    <span className="classic__skins-avatar-chance">42.85%</span>
                </div>
                <div className="classic__skins-avatar-container">
                    <Avatar />
                    <span className="classic__skins-avatar-chance">42.85%</span>
                </div>
                <div className="classic__skins-avatar-container">
                    <Avatar />
                    <span className="classic__skins-avatar-chance">42.85%</span>
                </div>
                <div className="classic__skins-avatar-container">
                    <Avatar />
                    <span className="classic__skins-avatar-chance">42.85%</span>
                </div>
            </div>
            <div className="classic__skins-down-container">
                <LineSkin />
                <LineSkin />
                <LineSkin />
                <LineSkin />
                <LineSkin />
            </div>
        </div>
    );
};
